const getApiUrl = () => {
    const hostname = window.location.hostname;

    if (hostname.includes("laravel.cloud")) {
        // If on a laravel.cloud domain, map the frontend to the correct backend subdomain
        const backendHost = hostname.replace("frontend-", "backend-");
        return `https://${backendHost}/api`;
    }

    // Default to your active Laravel backend
    // return "http://jlocalhost:8000/api";
    return "https://backend-production-lgw8cu.laravel.cloud/api";

};

const API_BASE_URL = getApiUrl();
export default API_BASE_URL;
